import { GENERAL_DISEASE, OTHER_DISEASE } from 'utils/constants/disease';
import { observeStore } from 'functions/observeStore';
// eslint-disable-next-line import/no-cycle
import { store } from 'utils/store';
// eslint-disable-next-line import/no-cycle
import { getMissingCriticalQuestions, getTopGroups } from 'new-ui/functions';
import missingQuestionsTransformer, {
  MISSING_CRITICAL_TO_QUESTION,
} from 'new-ui/functions/missingQuestionsTransformer';

export const getIntercomMissingCriticalObject = (user, trials) => {
  let missing_critical_info = getMissingCriticalQuestions(user, trials) || [];
  missing_critical_info = missing_critical_info.map((prop) => {
    for (const x in missingQuestionsTransformer) {
      const d = missingQuestionsTransformer[x];
      if (d.includes(prop) && MISSING_CRITICAL_TO_QUESTION[x]) return x;
    }
    return prop;
  });
  missing_critical_info = missing_critical_info.map((prop) => {
    if (
      Object.keys(MISSING_CRITICAL_TO_QUESTION).includes(prop)
    ) return MISSING_CRITICAL_TO_QUESTION[prop];
    return prop;
  });
  missing_critical_info = [...new Set(missing_critical_info)];

  const o = {};
  for (let x = 0; x < 10; x += 1) {
    const q = missing_critical_info[x];
    o[`missing_${x + 1}`] = q || '';
    o[`missing_${x + 1}t`] = q ? window.t(`missing_critical.question.${q}`) : '';
  }
  return o;
};

export const getTopGroupsForIntercom = (trials) => {
  const groups = getTopGroups(trials);
  const len = Object.keys(groups).length;
  let s = '';
  let i = 0;
  if (len === 1) return `${groups[Object.keys(groups)[0]]} ${Object.keys(groups)[0]}`;
  for (const x in groups) {
    if (i === 0) s += `${groups[x]} ${x}`;
    else if (i === len - 1) s += ` and ${groups[x]} ${x}`;
    else s += `, ${groups[x]} ${x}`;
    i += 1;
  }
  return s;
};

export const isEmpty = (value) => value === undefined || value === null || (typeof value === 'object' && Object.keys(value).length === 0);

export const getIntercomUserCondition = ({ value, type }) => {
  if (value === OTHER_DISEASE) {
    return 'ALL';
  }
  if (value === GENERAL_DISEASE && type) {
    return type;
  }
  return value;
};

export function watchIntercomPopups(callback) {
  const observer = new MutationObserver(() => {
    const popupFrame = document.querySelector('iframe[name="intercom-modal-frame"], iframe[name="intercom-messenger-frame"]');
    if (popupFrame && !popupFrame.__intercomDetected) {
      popupFrame.__intercomDetected = true;
      callback(true, popupFrame);
    } else if (!popupFrame) {
      callback(false, null);
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
}

export const observeIsAppPopupShownStore = (onChange) => observeStore(
  store,
  (state) => {
    const { popup: { popup } } = state;
    return !!popup;
  },
  (isAppPopupShown) => {
    onChange(isAppPopupShown);
  },
);

const getIntercomContainer = () => document.getElementById('intercom-container');

export const showIntercomContainer = () => {
  const $intercomContainer = getIntercomContainer();
  if (!$intercomContainer) {
    return;
  }
  $intercomContainer.classList.add('display-intercom-container');
};

export const hideIntercomContainer = () => {
  const $intercomContainer = getIntercomContainer();
  if (!$intercomContainer) {
    return;
  }
  $intercomContainer.classList.remove('display-intercom-container');
};
